module.exports = __webpack_public_path__ + "static/img/story1.b73c646.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/story1.jpg
// module id = ZFoh
// module chunks = 0